import * as React from 'react';
import { BaseInputField } from '../../components/BaseInputField';
import { jsx as _jsx } from "react/jsx-runtime";
export var StringFieldContainer = function StringFieldContainer(props) {
  return /*#__PURE__*/_jsx(BaseInputField, {
    label: props.label,
    name: props.name,
    autoFocus: props.autoFocus,
    placeholder: props.placeholder,
    leftAdornment: props.prefix,
    rightAdornment: props.unit
  });
};
StringFieldContainer.displayName = 'StringFieldContainer';